import { Component } from '@angular/core';
import  axios from 'axios';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'indistrict';
  h_4; h_5; h_6; h_7;
  name; email; tel; message; check_line; check_contact; check_visit;

  constructor() {}

  ngOnInit() {
    if(screen.width <= 575) {
      document.getElementById("img-4").style.height = "auto";
      document.getElementById("img-5").style.height = "auto";
      document.getElementById("img-6").style.height = "auto";
      document.getElementById("img-7").style.height = "300px";
    } else {
      this.h_4 = document.getElementById('bg-color-4').offsetHeight;
      document.getElementById("img-4").style.height = (parseInt(this.h_4))+"px";
      this.h_5 = document.getElementById('bg-color-5').offsetHeight;
      document.getElementById("img-5").style.height = (parseInt(this.h_5))+"px";
      this.h_6 = document.getElementById('bg-color-6').offsetHeight;
      document.getElementById("img-6").style.height = (parseInt(this.h_6))+"px";
      this.h_7 = document.getElementById('bg-color-7').offsetHeight;
      document.getElementById("img-7").style.height = (parseInt(this.h_7))+"px";
    }    
  }

  contact() {
    window.location.href = '#footer'
  }

  mail_regis(form) {
    // console.log(form.value);
    switch(form.value.budget_regis) {
      case "1":
        var budget_regis = "1,000,000-2,000,000";
        break;
      case "2":
        var budget_regis = "3,000,000-4,000,000";
        break;
      case "3":
        var budget_regis = "5,000,000-6,000,000";
        break;
      case "4":
        var budget_regis = "7,000,000-8,000,000";
        break;
      case "5":
        var budget_regis = "9,000,000 ขึ้นไป";
        break;
      default:
        var budget_regis = "0";
    }
    // console.log(budget, form.value.name_regis.length, form.value.tel_regis.length);
    if(form.value.name_regis.length == 0 || form.value.tel_regis.length == 0) {
      alert("กรุณากรอกชื่อและเบอร์โทรศัพท์ให้ครบ");
    } else {
      axios({
        method: 'post',
        url: 'https://mail.gethomestay.com/acad',
        data: {
          "name" : form.value.name_regis,
          "email" : form.value.email_regis,
          "subject" : ": Contact from Indistrict Website",
          "message" : "< Phone Number: " + form.value.tel_regis + " >, Line ID: "+ form.value.line_regis + "\n" + "โดยมี Budget: " + budget_regis + "บาท",
          "recipients" : ["Athithan@gritworld.co.th", "win@gritworld.co.th", "leadnotify.grit@gmail.com", "cto@gritworld.co.th", "Chanaphat@gritworld.co.th", "ranchida@gritworld.co.th"]
        }
      }).then(response => {
        console.log(response);
        alert("ข้อมูลของท่านถูกส่งเรียบร้อย");
        window.location.reload();
      }).catch(function (error) {
        console.log(error);
        alert("ข้อมูลของท่านไม่ถูกส่ง");
      });
    }
  }

  mail(form) {
    // console.log(form.value);
    if(form.value.check_line == true) { var check_line = 'รับข้อมูลโครงการเพิ่มเติมผ่านทาง LINE Application'; }
    if(form.value.check_contact == true) { var check_contact = 'ต้องการให้ติดต่อกลับ'; }
    if(form.value.check_visit == true) { var check_visit = 'ต้องการนัดเยี่ยมชมโครงการ'; }
    switch(form.value.budget) {
      case "1":
        var budget = "1,000,000-2,000,000";
        break;
      case "2":
        var budget = "3,000,000-4,000,000";
        break;
      case "3":
        var budget = "5,000,000-6,000,000";
        break;
      case "4":
        var budget = "7,000,000-8,000,000";
        break;
      case "5":
        var budget = "9,000,000 ขึ้นไป";
        break;
      default:
        var budget = "0";
    }
    // console.log(check_line, check_contact, check_visit, budget, form.value.name.length, form.value.tel.length);
    if(form.value.name.length == 0 || form.value.tel.length == 0) {
      alert("กรุณากรอกชื่อและเบอร์โทรศัพท์ให้ครบ");
    } else {
      axios({
        method: 'post',
        url: 'https://mail.gethomestay.com/acad',
        data: {
          "name" : form.value.name,
          "email" : form.value.email,
          "subject" : ": Contact from Indistrict Website",
          "message" : "< Phone Number: " + form.value.tel + " >, Line ID: "+ form.value.line + "\n" +
                      "ลูกค้าต้องการ" + check_line + " " + check_contact + " " + check_visit + " " +
                      "โดยมี Budget: " + budget + "บาท",
          "recipients" : ["Athithan@gritworld.co.th", "win@gritworld.co.th", "leadnotify.grit@gmail.com", "cto@gritworld.co.th", "Chanaphat@gritworld.co.th", "ranchida@gritworld.co.th"]
        }
      }).then(response => {
        console.log(response);
        alert("ข้อมูลของท่านถูกส่งเรียบร้อย");
        window.location.reload();
      }).catch(function (error) {
        console.log(error);
        alert("ข้อมูลของท่านไม่ถูกส่ง");
      });
    }
  }
}
